const config = {
  firebase: {
    apiKey: "AIzaSyBsPi_ZQvqk86p4NQrKshbLiDr5wVI6WL0",
    authDomain: "mnemory-project.firebaseapp.com",
    projectId: "mnemory-project",
    storageBucket: "mnemory-project.appspot.com",
    messagingSenderId: "254331690784",
    appId: "1:254331690784:web:d56e687c0a89b11c650145",
    measurementId: "G-CX7Y88WL7M",
  },
  server: {
    url: "https://mnemory.onrender.com", // http://localhost:8001 
  },
};

export default config;
